// Conficguracion de NavMenu lateral (SideBar)

import React from 'react';
import { useUser } from './UserContext';
import { Drawer } from '@mui/material';
import './App.css';
import GButton from "./components/GButton"
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function NavMenu({ onNavigate }) {
  const { user, setUser, hasRole, isMobile } = useUser();
  const [submenuOpen, setSubmenuOpen] = React.useState(false);

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    onNavigate('login');
  };

  const navButtonStyle = {
    display: 'block',
    width: '100%',
    padding: '8px',
    margin: '10px 0',
    backgroundColor: '#144272',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    textAlign: 'left',
  };

  const subNavButtonStyle = {
    display: 'block',
    width: '100%',
    padding: '5px',
    margin: '4px 0',
    backgroundColor: '#1b5e9a',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '13px'
  };

  const MenuContent = () => (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0a2647',
        color: 'white',
        boxSizing: 'border-box',
        paddingTop: '90px',
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingBottom: '1rem'
      }}
    >

      {!isMobile && (
        <div
          style={{
            textAlign: 'center',
            marginTop: isMobile ? 'auto' : 0,
            marginBottom: 20
          }}
        >

          <img
            src="/gosen_logo_final_blanco.png"
            alt="Gosen Logo"
            style={{
              width: '150px',
              cursor: 'pointer'
            }}
            onClick={() => onNavigate('home')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          />
        </div>
      )}

      {/* MENU */}

      <div style={{ flexGrow: 1 }}>
        {user ? (
          <>
            <GButton variant="navButton" onClick={() => onNavigate('dashboard')}>Dashboard</GButton>

            {/* SUBMENU */}
            <GButton variant="navButton"
              style={{
                ...navButtonStyle,
                display: 'flex',
                justifyContent: 'space-between'
              }}
              onClick={() => setSubmenuOpen(prev => !prev)}
            >
              Asistencia y Turnos
              {submenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </GButton>

            {submenuOpen && (
              <div style={{ paddingLeft: 10 }}>
                <GButton variant="navSubMenuButton"
                  style={subNavButtonStyle}
                  onClick={() => onNavigate('attendance')}
                >
                  Registro de asistencia
                </GButton>

                {hasRole(['ADMIN', 'SUPERVISOR']) && (
                  <GButton variant="navSubMenuButton"
                    style={subNavButtonStyle}
                    onClick={() => onNavigate('shift-assignment')}
                  >
                    Asignación de turnos
                  </GButton>
                )}
              </div>
            )}

            {hasRole(['ADMIN']) && (
              <GButton variant="navButton" onClick={() => onNavigate('users')}>
                Usuarios
              </GButton>
            )}

            {hasRole(['ADMIN','HR_ADMIN', 'SUPERVISOR']) && (
              <GButton variant="navButton" onClick={() => onNavigate('clients')}>
                Clientes
              </GButton>
            )}

            {hasRole(['ADMIN', 'HR_ADMIN']) && (
              <GButton variant="navButton" onClick={() => onNavigate('quotations')}>
                Cotizaciones
              </GButton>
            )}

            {hasRole(['ADMIN', 'HR_ADMIN']) && (
              <GButton variant="navButton" onClick={() => onNavigate('contracts')}>
                Contratos
              </GButton>
            )}


            <GButton variant="navButton" onClick={() => onNavigate('reports')}>
              Reportes
            </GButton>


            {hasRole(['ADMIN', 'HR_ADMIN']) && (
              <GButton variant="navButton" onClick={() => onNavigate('payroll')}>
                Nómina
              </GButton>
            )}
          </>
        ) : (
          <p>No existe usuario</p>
        )}
      </div>

      {isMobile && (
        <div
          style={{
            flexGrow: 6,
            textAlign: 'center',
            marginTop: 'auto',
            marginBottom: '10px'
          }}>

          <img
            src="/gosen_logo_final_blanco.png"
            alt="Gosen Logo"
            style={{ width: '150px', cursor: 'pointer' }}
            onClick={() => onNavigate('home')}
          />
        </div>
      )}
    </div >
  );

  return (
    <>
      {/* SIDEBAR */}
      {!isMobile && user && (
        <div
          style={{
            width: '200px',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            backgroundColor: '#0a2647'
          }}
        >
          <MenuContent />
        </div>
      )}

      {/* MOVIL DRAWER */}
      {isMobile && (
        <MenuContent />
      )}
    </>
  );
}